import { jsx as _jsx } from "react/jsx-runtime";
import { Public, TravelExplore, VolunteerActivism } from "@mui/icons-material";
import { EmptyState } from "../../shared/EmptyState";
export const GlobalReferralsEmptyState = () => {
    return (_jsx(EmptyState, { backgroundIcon: Public, primaryIcon: TravelExplore, accentIcon: VolunteerActivism, title: "No Global Referrals Nearby", description: "When clients choose to join the Global Referrals List in your area, they will appear here. This is where you can discover and review open referral opportunities." }));
};
